import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { PlatformPage } from './pages/Platform';
import { SolutionsPage } from './pages/Solutions';
import { WhyROIPage } from './pages/WhyROI';
import { ResourcesPage } from './pages/Resources';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/platform" element={<PlatformPage data-id="element-5" />} data-id="element-4" />
        <Route path="/solutions" element={<SolutionsPage data-id="element-7" />} data-id="element-6" />
        <Route path="/why-roi" element={<WhyROIPage data-id="element-9" />} data-id="element-8" />
        <Route path="/resources" element={<ResourcesPage data-id="element-11" />} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}